export default __webpack_public_path__ + "static/media/white-oak.7fba8b3a.webp";